import type { SVGProps } from 'react';
const SvgCarpenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#carpenter_svg__a)">
      <path
        fill="currentColor"
        d="M19.73 14.23 7 1.5 3.11 5.39l8.13 11.67c-.78.78-.78 2.05 0 2.83l1.41 1.41c.78.78 2.05.78 2.83 0l4.24-4.24c.79-.78.79-2.05.01-2.83Zm-5.66 5.65-1.41-1.41 4.24-4.24 1.41 1.41-4.24 4.24Z"
      />
    </g>
    <defs>
      <clipPath id="carpenter_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCarpenter;
